<template>
  <InformationIcon />

  <div class="as-d-flex as-flex-column as-box-match-info">
    <div class="as-item as-d-flex as-align-items-center">
      <div class="as-icon">
        <img
          :src="
            getImgUrlBySport(
              'competition',
              match.tournament?.id ?? match.tournament_id
            )
          "
          class="as-icon"
          width="37"
          height="37"
        />
      </div>
      <div class="as-info">
        <div class="as-name">Giải đấu</div>
        <div class="as-nation">{{ match.tournament?.name ?? "-" }}</div>
      </div>
    </div>
    <div class="as-item as-d-flex as-align-items-center">
      <div class="as-icon">
        <IconTournamentTime />
      </div>
      <div class="as-info">
        <div class="as-name">Thời gian thi đấu</div>
        <div class="as-nation">{{ showMatchTime(match.match_time) }}</div>
      </div>
    </div>
    <div class="as-item as-d-flex as-align-items-center">
      <div class="as-icon">
        <IconTournamentVenue />
      </div>
      <div class="as-info">
        <div class="as-name">Địa điểm</div>
        <div class="as-nation">{{ match.venue?.city }}</div>
      </div>
    </div>
    <div class="as-item as-d-flex as-align-items-center">
      <div class="as-icon">
        <IconTournamentCourt />
      </div>
      <div class="as-info">
        <div class="as-name">Sân thi đấu</div>
        <div class="as-nation">{{ match.venue?.name }}</div>
      </div>
    </div>
    <div class="as-item as-d-flex as-align-items-center">
      <div class="as-icon">
        <IconTournamentTypeOfCourt />
      </div>
      <div class="as-info">
        <div class="as-name">Loại sân</div>
        <div class="as-nation">
          {{ convertCourtType(match.tournament?.ground_id || 0) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import type { IMatchTennis } from "~src/interfaces/tennis";
import InformationIcon from "~src/components/matches/InformationIcon.vue";
import StatsEnum from "~src/enums/tennis/StatsEnum";
import IconTournamentCourt from "~src/components/icons/IconTournamentCourt.vue";
import IconTournamentTime from "~src/components/icons/IconTournamentTime.vue";
import IconTournamentTypeOfCourt from "~src/components/icons/IconTournamentTypeOfCourt.vue";
import IconTournamentVenue from "~src/components/icons/IconTournamentVenue.vue";
import MatchEnum from "~src/enums/tennis/MatchEnum";

interface IProps {
  match: IMatchTennis;
}

const props = withDefaults(defineProps<IProps>(), {});

const showMatchTime = computed(() => (timestamp: string | number) => {
  const timeValue =
    typeof timestamp === "string" ? parseInt(timestamp) : timestamp;

  const date = new Date(timeValue * 1000);
  const formatter = new Intl.DateTimeFormat("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formatter.format(date);
});

const convertCourtType = computed(() => (group_id: number) => {
  const groundTypeText = MatchEnum.GROUND_TYPE_STTAUS as Record<number, string>;

  return groundTypeText[group_id] || "-";
});
</script>

<script lang="ts">
export default {};
</script>
